import { Fragment } from 'react';
import { twMerge } from 'tailwind-merge';
import { Card } from '@/components/ui/daisy';
import Text from '@/components/ui/custom/dataDisplay/Text';
import { AnswerContent } from '@/components/question/view/primitives/shared/AnswerContent';
import {
  CombinationCorrectionEntry,
  CombinationCorrectionStatus,
} from '@/components/question/view/typologies/combination/useCombinationCorrection';

type CombinationResultCardProps = {
  entry: CombinationCorrectionEntry;
  label: string;
};

const cardClasses: Record<CombinationCorrectionStatus, string> = {
  correct: 'bg-success-content border-success text-success',
  incorrect: 'bg-error-content border-error text-error',
  empty: 'bg-base-300 border-base-content text-base-content',
};

export function CombinationResultCard({
  entry,
  label,
}: CombinationResultCardProps) {
  const { answer, status } = entry;

  return (
    <Card
      className={twMerge(
        'flex min-h-16 flex-1 flex-row items-center justify-between gap-4 border p-4 font-poppins',
        cardClasses[status],
      )}
    >
      {answer && (
        <Fragment>
          <AnswerContent answer={answer} className="font-600 text-lg" />
          <Text text={label} size="text-sm" className="shrink-0 font-700" />
        </Fragment>
      )}
    </Card>
  );
}
